import { render, staticRenderFns } from "./CrearSolicitud.vue?vue&type=template&id=bb2bc0ce&scoped=true&"
import script from "./CrearSolicitud.vue?vue&type=script&lang=ts&"
export * from "./CrearSolicitud.vue?vue&type=script&lang=ts&"
import style0 from "./CrearSolicitud.vue?vue&type=style&index=0&id=bb2bc0ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2bc0ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bb2bc0ce', component.options)
    } else {
      api.reload('bb2bc0ce', component.options)
    }
    module.hot.accept("./CrearSolicitud.vue?vue&type=template&id=bb2bc0ce&scoped=true&", function () {
      api.rerender('bb2bc0ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SolicitudBajaSim/Crear/CrearSolicitud.vue"
export default component.exports